<div
    [class.container]="isVerticalLayout$ | async"
    class="toolbar text-default w-full px-6 flex items-center"
>
    <button
        (click)="openSidenav()"
        [class.hidden]="isDesktop$ | async"
        mat-icon-button
        type="button"
    >
        <mat-icon class="material-symbols-outlined">menu</mat-icon>
    </button>

    <a
        *ngIf="isVerticalLayout$ | async"
        [routerLink]="['/']"
        class="ltr:mr-4 rtl:ml-4 flex items-center"
    >
        <img alt="Logo" class="w-8 select-none" src="assets/img/logo/logo.png" />
        <h1
            [class.hidden]="isDesktop$ | async"
            class="text-2xl font-bold tracking-wide ltr:pl-4 rtl:pr-4 m-0 select-none"
        >
            {{ title$ | async }}
        </h1>
    </a>

    <div
        *ngIf="(isVerticalLayout$ | async) && (isNavbarInToolbar$ | async)"
        [class.hidden]="(isDesktop$ | async) === false"
        class="px-6 flex-none flex items-center"
    >
        <vex-navigation-item
            *ngFor="let item of navigationItems$ | async"
            [item]="item"
        ></vex-navigation-item>
    </div>

    <span class="flex-1"></span>

    <div class="-mx-1 flex items-center">
        <div *ngIf="userVisible$ | async" class="px-1">
            <vex-toolbar-user></vex-toolbar-user>
        </div>
        <div class="px-1">
            <vex-toolbar-notifications></vex-toolbar-notifications>
        </div>
    </div>
</div>

<vex-navigation
    *ngIf="(isVerticalLayout$ | async) && (isNavbarBelowToolbar$ | async)"
    [class.hidden]="(isDesktop$ | async) === false"
></vex-navigation>
